import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from 'react';
import {useDispatch} from 'react-redux';
import {showGlobalMessage} from '../_common/components/GlobalMessage/actions/showGlobalMessage';
import {messages as M} from '../../../_metronic/i18n/messages';
import {getDashboardStats} from './actions/DashboardPageChartsActions';

const InfoBoxesContext = createContext('');

export function useInfoBoxesContext() {
  return useContext(InfoBoxesContext);
}

export function InfoBoxesContextProvider({children}) {
  const dispatch = useDispatch();
  const initialData = {
    openPriceQuotes: '',
    newOrders: '',
    inspectionsInProgress: '',
    inspectionsPending: '',
    moneyRemain: '',
    inspectionsCurrentWeek: '',
  };
  const [data, setData] = useState(initialData);

  const getData = async () => {
    try {
      let result = await getDashboardStats();
      setData(result);
    } catch (e) {
      console.error(e);
      dispatch(showGlobalMessage('error', M['-1']));
      setData(initialData);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getValue = (value) => {
    return value || value === 0 ? value : '';
  };

  return (
    <InfoBoxesContext.Provider
      value={{
        openPriceQuotes: getValue(data?.openPriceQuotes),
        newOrders: getValue(data?.newOrders),
        inspectionsInProgress: getValue(data?.inspectionsInProgress),
        inspectionsPending: getValue(data?.inspectionsPending),
        moneyRemain: getValue(data?.moneyRemain),
        inspectionsCurrentWeek: getValue(data?.inspectionsCurrentWeek),
      }}
    >
      {children}
    </InfoBoxesContext.Provider>
  );
}
